import Box from '@mui/material/Box'
import Typography from '@mui/material/Typography'
import { observer } from 'mobx-react'
import { useIntl } from 'react-intl'
import { getImageSrc } from '../../../../../helpers/getImageSrc'
import { openModalFn } from '../../../../../utils/controllers/ModalController'
import {
  containerSx,
  getActionWrapperSx,
  getImageStyles,
} from '../../../../SingleRequestPage/consts/image-styles'
import { RequestType } from '../../../../SingleRequestPage/types/Request.type'
import React = require('react')

interface NewUploadedPhotosProps {
  request: RequestType
  images: any
  deleteImage: (id: number) => void
}

function NewUploadedPhotos({
  images,
  request,
  deleteImage,
}: NewUploadedPhotosProps) {
  const intl = useIntl()
  const [deleteIdx, setDeleteIdx] = React.useState<number | null>(null)
  const { install, impossible, uncompleted, clarify, reportedEdit } = images
  const data = [
    { name: intl.formatMessage({ id: 'Установка' }), collection: install },
    {
      name: intl.formatMessage({ id: 'Установка невозможна' }),
      collection: impossible,
    },
    {
      name: intl.formatMessage({ id: 'На доработку' }),
      collection: uncompleted,
    },
    {
      name: intl.formatMessage({ id: 'Уточнение данных' }),
      collection: clarify,
    },
    {
      name: intl.formatMessage({ id: 'Новая установка' }),
      collection: reportedEdit,
    },
  ]
  const { status, dataCheckingStatus, reportStatus } = request

  const deletePhoto = () => {
    if ([3].includes(reportStatus!)) {
      const inStatus13 =
        [13].includes(status) && [3].includes(dataCheckingStatus)
      // Отчеты
      return inStatus13 || status === 14
    }

    return [6].includes(status)
  }

  const setImagesBlock = ({ name, collection }: any) => {
    if (!collection?.length) return null

    return (
      collection?.length && (
        <Box mb={1}>
          <Typography
            variant={'body2'}
            color={'grey.500'}
            sx={{ lineHeight: 1, marginBottom: '10px' }}
          >
            {name}
          </Typography>
          <Box
            mt={0.5}
            sx={{
              display: 'flex',
              width: '100%',
              flexWrap: 'wrap',
              gap: '4px',
            }}
          >
            {collection.map((el: any, i: any) => (
              <Box
                sx={containerSx}
                onClick={() => {
                  openModalFn?.['photo-gallery']?.({
                    collection,
                    initialIndex: i,
                    name,
                  })
                }}
                onMouseMove={() => setDeleteIdx(el.id)}
                onMouseLeave={() => setDeleteIdx(null)}
              >
                <Box
                  key={i}
                  component={'img'}
                  src={el.url}
                  alt={`изображение-${i}`}
                  sx={{
                    ...getImageStyles(false),
                    border: '1px solid green !important',
                    outlineWidth: '0',
                  }}
                />
                {el.id === deleteIdx && deletePhoto() && (
                  <Box
                    sx={getActionWrapperSx(false)}
                    onClick={(e: any) => {
                      e.stopPropagation()
                      deleteImage(el.id)
                    }}
                  >
                    <img
                      alt={'remove photo'}
                      src={getImageSrc('close-light')}
                      width={20}
                      height={20}
                    />
                  </Box>
                )}
              </Box>
            ))}
          </Box>
        </Box>
      )
    )
  }

  return <Box mt={2}>{data.map((el) => setImagesBlock(el))}</Box>
}

export default observer(NewUploadedPhotos)
